export default __webpack_public_path__ + "static/media/(78).8219bef4.jpg";